import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import * as core from 'hub-http/middlewares/core';
import * as hubapi from 'hub-http/middlewares/hubapi';
// @ts-expect-error not typescript
import * as debug from 'hub-http/middlewares/debug';
// @ts-expect-error not typescript
import * as externalAuth from 'hub-http/middlewares/externalAuth';

// Short-circuits redirectTo so no auth-failure redirect (missing portalId/CSRF or
// 401) navigates the page. Must run before cookieAuthentication.
const ignoreLoginRedirects = options => Object.assign({}, options, {
  ignoreRedirect: true
});

// hub-http/stacks/hubapi, minus the login redirect: ignoreLoginRedirects blocks the
// navigation and logoutOnUnauthorized is omitted so a 401 rejects cleanly, letting
// the caller retry against noAuthApiClient.
export default promiseClient(createStack(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, ignoreLoginRedirects, externalAuth.cookieAuthentication, core.withQuery, debug.rewriteUrl, debug.enableFailureInjection, hubapi.timeoutInQuery, hubapi.setRequest, core.reportOptionsError, core.enableMigrationCheckBypass, core.redirectOnMigrationInProgress, core.redirectOnPortalMoved, hubapi.retryOnError, core.validateStatus, core.jsonResponse));